import { render, staticRenderFns } from "./DataOutlet.vue?vue&type=template&id=1385dcc2&"
import script from "./DataOutlet.vue?vue&type=script&lang=js&"
export * from "./DataOutlet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports